// src/components/home/copy.js
// 홈 B2B 리뉴얼 전체 카피 단일 소스. 문구/링크 변경은 이 파일만 수정.
// 3블록(HERO/CAPABILITY/PROPOSAL) + 푸터(FOOTER) + 메타(META).

// 파트너십 문의 메일 — 기존 코드(business/ContactForm.jsx)의 대표 문의 주소 재사용
const PARTNERSHIP_EMAIL = 'kwh@beneficial.co.kr';
// 파트너십 문의 mailto — 제목 프리필. 히어로·기업호텔 두 버튼이 동일하게 사용.
const PARTNERSHIP_MAILTO = `mailto:${PARTNERSHIP_EMAIL}?subject=${encodeURIComponent('[올림 파트너십 문의]')}`;

export const HERO = {
  // BLOCK 01 · 히어로 (회사 정체성 직격)
  titleLead: '올림은 ',
  titleAccent: '경험·무브먼트 컴퍼니', // 그라데이션 강조 부분
  titleTail: '입니다.',
  subtitle: '잊지 못할 스포츠 경험을 설계해, 사람이 스스로 모여드는 장을 만듭니다.',
  ctaLabel: '파트너십 문의하기',
  ctaHref: PARTNERSHIP_MAILTO, // 바로 메일 열림 (제안 섹션 mailto와 동일)
  bgImage: 'src/assets/images/hero-action.jpg', // 기록용(문서). 실제 로딩은 컴포넌트(HeroIdentity)의 Vite import가 담당
};

export const CAPABILITY = {
  // BLOCK 02 · 역량 (3개 기둥)
  head: '광고는 사라집니다. 사람이 모인 장면은 남습니다.',
  pillars: [
    {
      title: '이미 돌아가는 판',
      body: 'JW 테니스와 실제 대회를 열어왔습니다.\n검증되지 않은 실험이 아니라, 작동하는 무대입니다.',
    },
    {
      title: '사람을 소유하는 구조',
      body: '참가자의 경험·기록·연결이 올림 자산으로 축적됩니다.\n파트너는 그 위에 이름을 얹습니다.\n한 번의 노출이 아니라, 계속 돌아오는 청중입니다.',
    },
    {
      title: '경쟁이 설 수 없는 자리',
      body: '남들은 경기를 기록하고 중계합니다.\n올림은 평범한 사람을 선수로 만듭니다.\n기능이 아니라 정체성입니다.',
    },
  ],
};

export const PROPOSAL = {
  // BLOCK 03 · 제안 (동선 분리)
  head: '당신의 이름을, 이 판 위에.',
  cards: [
    {
      key: 'company',
      eyebrow: '기업',
      title: '딱딱한 조직을 젊은 세대가 열광하는 문화로.',
      body: '함께 뛰는 하루가 부서의 벽을 낮추고 수평적 문화를 만듭니다.\n"복지 이벤트 하나 더"가 아니라, 조직문화를 바꾼 회사입니다.',
      slot: 'src/assets/images/card-corporate.jpg', // 기록용(문서). 실제 로딩은 컴포넌트(PartnershipProposal)의 Vite import가 담당
    },
    {
      key: 'venue',
      eyebrow: '호텔·시설',
      title: '유휴 시간대를 사람이 모이는 목적지로.',
      body: '커뮤니티를 데려오고 콘텐츠·재방문·멤버십으로 연결합니다.\n공간 대여가 아니라, 목적지가 되는 일입니다.',
      slot: 'src/assets/images/card-hotel.jpg', // 기록용(문서). 실제 로딩은 컴포넌트(PartnershipProposal)의 Vite import가 담당
    },
  ],
  ctaLabel: '파트너십 문의하기',
  ctaHref: PARTNERSHIP_MAILTO, // 대표 문의 메일 + 제목 프리필
};

export const GALLERY = {
  // 대회 갤러리 (히어로 아래) — 현장 실적으로 증명
  headline: '현장으로 증명합니다',
  subcopy: 'JW 테니스와 실제 대회를 열어왔습니다.\n광고가 아니라, 사람이 모인 기록입니다.',
  // images[].file은 기록용(문서). 실제 로딩은 컴포넌트의 Vite import가 담당(연결 단계에서).
  // alt: 동일 시상식(2026-06-03) 3장이라 통일.
  images: [
    { file: 'src/assets/images/IMG_20260603_163851.jpg', alt: '제2회 JW×OLYM 테니스 오픈 시상식' },
    { file: 'src/assets/images/IMG_20260603_175726.jpg', alt: '제2회 JW×OLYM 테니스 오픈 시상식' },
    { file: 'src/assets/images/IMG_20260603_175732.jpg', alt: '제2회 JW×OLYM 테니스 오픈 시상식' },
  ],
};

export const HOST = {
  // 홈 → 호스트 신청 진입 CTA (PartnershipProposal와 HomeFooter 사이)
  headline: '당신의 판을 열고 싶다면',
  subcopy: '대회·크루·이벤트 — 모집과 결제, 운영을 올림이 함께합니다.',
  ctaLabel: '주최자 신청',
  ctaHref: '/host/',
};

export const FOOTER = {
  // 푸터(작게) — B2C·SaaS 회수 동선
  links: [
    { label: '참가자이신가요? 이벤트·크루 둘러보기', href: '/download', external: false },
    { label: '센터를 운영하시나요? 운영 솔루션 보기', href: '/business', external: false },
  ],
  legal: [
    { label: '개인정보처리방침', href: 'https://olym-beneficial.notion.site/2364365aa24c80ce8b3cec5342fe3ba4' },
    { label: '이용약관', href: 'https://olym-beneficial.notion.site/1bc4365aa24c80b49251ec2cdc905e02' },
  ],
  copyright: '© olym',
};

// index.html용 메타(참고 상수 — 실제 반영은 index.html에서 직접 교체)
export const META = {
  title: 'olym — 경험·무브먼트 컴퍼니',
  description: '잊지 못할 스포츠 경험을 설계해, 사람이 스스로 모여드는 장을 만듭니다.',
};
